import { render, staticRenderFns } from "./assessors.vue?vue&type=template&id=37f5d5f8&scoped=true"
import script from "./assessors.vue?vue&type=script&lang=js"
export * from "./assessors.vue?vue&type=script&lang=js"
import style0 from "./assessors.vue?vue&type=style&index=0&id=37f5d5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5d5f8",
  null
  
)

export default component.exports